<mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" linear #stepper>

    <mat-step [stepControl]="refundForm">
      <ng-template matStepLabel>I. Osnovni podaci o Odluci o povratu</ng-template>
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">I. Osnovni podaci o Odluci o povratu</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="refundForm">
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Klasa</mat-label>
                <input matInput formControlName="classificationCode" />
              </mat-form-field>
            </div>
            <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Urudžbeni broj</mat-label>
                  <input matInput formControlName="referenceNumber" />
                </mat-form-field>
            </div>
            <mat-form-field class="mb-25">
              <mat-label>Datum Odluke o povratu:</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="date">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
  
            <button mat-flat-button matStepperNext color="primary" [disabled]="refundForm.invalid">
              Dalje
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    </mat-step>
  
    <!-- Step 2: Potvrda -->
    <mat-step>
      <ng-template matStepLabel>Potvrda</ng-template>
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">
              {{ isUpdating ? 'Ažuriranje' : 'Kreiranje' }} Odluke o povratu
            </h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <button mat-flat-button matStepperPrevious class="mr-15">
              Nazad
            </button>
            <button mat-flat-button color="primary" (click)="onSubmit()">
              Spremi
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-step>
  </mat-stepper>
  